import * as React from "react";

import AddressItem from "./AddressItem";
import AddressForm from "../AddressForm";

import Button from "../../Button";
import PageTitle from "../../PageTitle";
import Checkbox from "../../CheckBox";
import Selectbox from "../../Selectbox";
import Icon from "../../Icon";
import Modal from "../../Modal";
import { removeDuplicates } from "theme/utils";
import $S from "theme/settings";
import isEmpty from "lodash/isEmpty";

import "../style.less";

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const $C = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/checkout.json`);
const {
  DIRECTORY_THEME
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/checkout`);
const $ST = DIRECTORY_THEME.ADDRESS_SELECTION;

export default class AddressSelection extends React.Component {
  constructor(props) {
    super(props);

    const {
      currentAddress,
      currentRetailStore,
      currentBillAddress,
      currentDeliveryOption,
      defaultSameAddress
    } = this.props;

    this.state = {
      sameAddress:
        currentDeliveryOption.delivery_option_type === "retail_store"
          ? false
          : currentAddress &&
            currentBillAddress &&
            Object.keys(currentAddress).length > 0 &&
            Object.keys(currentBillAddress).length > 0
          ? currentAddress.pk === currentBillAddress.pk
          : [null, undefined].includes(defaultSameAddress)
          ? true
          : defaultSameAddress,
      currentAddress: currentAddress,
      currentBillAddress: currentBillAddress,
      isRetailStore:
        currentDeliveryOption.delivery_option_type === "retail_store",
      modals: {
        address: false
      },
      city: currentRetailStore.hasOwnProperty("township")
        ? currentRetailStore.township.city.pk
        : "",
      store: currentRetailStore.hasOwnProperty("pk")
        ? currentRetailStore.pk
        : ""
    };

    this.renderAddresses = this.renderAddresses.bind(this);
    this.renderBillingAddresses = this.renderBillingAddresses.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const {
      currentDeliveryOption,
      deliveryOptions,
      onSetDeliveryOption,
      onFetchCountries
    } = this.props;
    let customerDeliveryOption = [];

    onFetchCountries();

    if (
      !currentDeliveryOption.hasOwnProperty("delivery_option_type") &&
      deliveryOptions.length
    ) {
      customerDeliveryOption = deliveryOptions.filter((opt) => {
        return opt.delivery_option_type === "customer";
      });
      onSetDeliveryOption(
        customerDeliveryOption[0] ? customerDeliveryOption[0].pk : -1
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const prevState = this.state;
    const { currentAddress, currentBillAddress, currentDeliveryOption } =
      nextProps;
    this.setState({
      sameAddress:
        currentDeliveryOption.delivery_option_type === "retail_store"
          ? false
          : currentAddress
          ? currentAddress.pk === currentBillAddress.pk
            ? prevState.sameAddress
              ? true
              : false
            : false
          : true,
      currentAddress: currentAddress,
      currentBillAddress: currentBillAddress
    });
  }

  openModal(modalName) {
    this.setState({ modals: { [modalName]: true } });
  }

  closeModal() {
    this.setState({ modals: {}, address: {} });
  }

  setAddress(address_pk) {
    const { deliveryOptions, setDeliveryOptionWithAddress } = this.props;

    const customerDeliveryOption = deliveryOptions.length
      ? deliveryOptions.filter((opt) => {
          return opt.delivery_option_type === "customer";
        })
      : [];

    setDeliveryOptionWithAddress(
      address_pk,
      !this.state.sameAddress &&
        this.state.currentBillAddress.hasOwnProperty("pk")
        ? this.state.currentBillAddress.pk
        : address_pk,
      customerDeliveryOption[0] ? customerDeliveryOption[0].pk : -1
    );

    this.setState({
      isRetailStore: false
    });
  }

  setRetailStore(storePk) {
    const { onSetRetailStore } = this.props;
    const { currentBillAddress } = this.state;

    this.setState({
      store: storePk
    });

    if (currentBillAddress.hasOwnProperty("pk")) {
      onSetRetailStore(storePk, currentBillAddress.pk);
    }
  }

  setBillingAddress(pk) {
    const { onSetAddress, onSetRetailStore } = this.props;
    const { isRetailStore, store } = this.state;
    if (isRetailStore) {
      onSetRetailStore(store, pk);
    } else {
      onSetAddress(
        this.state.currentAddress ? this.state.currentAddress.pk : pk,
        pk
      );
    }
  }

  onEditAddress = (address) => {
    this.setState({ address }, () => this.openModal("address"));
  };

  onAddAddress = () => {
    this.setState({ address: null }, () => this.openModal("address"));
  };

  renderAddresses() {
    const { addresses, currentAddress, onDeleteAddress } = this.props;

    return addresses.map((address, index) => {
      return (
        <div className="col-xs-12 col-sm-6" key={index}>
          <AddressItem
            address={address}
            current={currentAddress ? address.pk === currentAddress.pk : false}
            onSet={(pk) => this.setAddress(pk)}
            type={address.is_corporate ? "address_corporate" : "address"}
            onEdit={this.onEditAddress}
            onDeleteAddress={(pk) => onDeleteAddress(pk)}
          />
        </div>
      );
    });
  }

  renderBillingAddresses() {
    const { addresses, currentBillAddress } = this.props;
    const type = "billing_address";
    return addresses.map((address, index) => {
      return (
        <div className="col-6" key={index}>
          <AddressItem
            address={address}
            current={
              currentBillAddress ? address.pk === currentBillAddress.pk : false
            }
            onSet={(pk) => this.setBillingAddress(pk)}
            type={type}
            onEdit={this.onEditAddress}
          />
        </div>
      );
    });
  }

  setSameAddress(checked) {
    this.setState(
      {
        sameAddress: checked
      },
      () => {
        if (this.state.currentAddress !== this.state.currentBillAddress) {
          this.props.onSetAddress(
            this.state.currentAddress.pk,
            this.state.currentAddress.pk
          );
        }
      }
    );
  }

  storeSelection() {
    const { deliveryOptions, onSetDeliveryOption } = this.props;
    let storeDeliveryOption = [];

    if (deliveryOptions.length) {
      storeDeliveryOption = deliveryOptions.filter((opt) => {
        return opt.delivery_option_type === "retail_store";
      });
      onSetDeliveryOption(
        storeDeliveryOption[0] ? storeDeliveryOption[0].pk : -1
      );
    }
    this.setState({
      isRetailStore: true
    });
  }

  checkDeliveryOptionType = (type) =>
    this.props.currentDeliveryOption !== null &&
    this.props.currentDeliveryOption.delivery_option_type === type;

  render() {
    const {
      onFetchCities,
      onFetchTownships,
      onFetchDistricts,
      onSendAddress,
      onDeleteAddress,
      retail_stores,
      cities,
      countries,
      townships,
      districts,
      customer,
      error
    } = this.props;
    const { address } = this.state;

    let storeCity = [];
    let stores = [];

    retail_stores.forEach((store) => {
      storeCity.push({
        label: store.township.city.name,
        value: store.township.city.pk
      });
    });

    retail_stores.forEach((store) => {
      if (
        store.township.city.pk === parseInt(this.state.city, 10) ||
        ["TFS"].includes($A.BRAND)
      ) {
        stores.push({
          label: store.name,
          value: store.pk
        });
      }
    });

    return (
      <div className="checkout-address">
        {this.state.modals.address && (
          <Modal onClose={this.closeModal}>
            <AddressForm
              fetchCities={(pk, name) => onFetchCities(pk, name)}
              fetchTownships={(pk) => onFetchTownships(pk)}
              fetchDistricts={(pk) => onFetchDistricts(pk)}
              submitAddress={(formData, pk) => onSendAddress(formData, pk)}
              onDeleteAddress={(pk) => onDeleteAddress(pk)}
              countries={countries}
              cities={cities}
              customer={customer}
              townships={townships}
              districts={districts}
              error={error}
              address={address}
            />
          </Modal>
        )}
        <div className="checkout-contents__header">
          <PageTitle>{$ST.DELIVERY_ADDRESS}</PageTitle>
          <div className="same__address">
            <Checkbox
              name="same_address"
              icon="check"
              value="true"
              disable={this.state.isRetailStore}
              checked={this.state.sameAddress}
              onChange={(checked) => this.setSameAddress(checked)}
            >
              <span className="float-left">{$ST.SAME_BILLING_ADDRESS}</span>
            </Checkbox>
          </div>
        </div>
        <div className="checkout-contents__body addresses">
          <p>{$ST.SELECT_DELIVERY_ADDRESS}</p>
          <div className="row">
            {this.renderAddresses()}
            <div className="col-xs-12 col-sm-6">
              <Button
                classes="checkout-address__item pointer new"
                onClick={() => this.openModal("address")}
              >
                <Icon icon="arti" />
                {$ST.CREATE_NEW_ADDRESS}
              </Button>
            </div>
            {$S.hasDeliveryFromStore && (
              <div className="col-xs-12 col-sm-6">
                {["TFS"].includes($A.BRAND) ? (
                  this.checkDeliveryOptionType("retail_store") &&
                  !isEmpty(this.props.addresses) ? (
                    <div className="checkout-address__item store-box">
                      <div className="store-title">
                        {$ST.DELIVERY_FROM_STORE}
                      </div>
                      <Selectbox
                        name="store"
                        icon="oksag"
                        value={this.state.store}
                        options={stores}
                        onChange={(value) => this.setRetailStore(value)}
                      />
                    </div>
                  ) : (
                    $C.HAS_DELIVERY_FROM_STORE && (
                      <Button
                        classes={`checkout-address__item pointer new ${
                          isEmpty(this.props.addresses)
                            ? "click-and-collect-disabled"
                            : ""
                        }`}
                        onClick={() => this.storeSelection()}
                      >
                        <span>{$ST.DELIVERY_FROM_STORE2}</span>
                        {isEmpty(this.props.addresses) && (
                          <span>{$ST.ADDRESS_MUST_BE_ADDED_FOR_INVOCE}</span>
                        )}
                      </Button>
                    )
                  )
                ) : this.checkDeliveryOptionType("retail_store") ? (
                  <div className="checkout-address__item store-box">
                    <div className="store-title">{$ST.DELIVERY_FROM_STORE}</div>
                    <Selectbox
                      name="city"
                      icon="oksag"
                      options={removeDuplicates(storeCity, "label")}
                      value={this.state.city}
                      onChange={(value) =>
                        this.setState({ city: value, store: "" })
                      }
                    />
                    {this.state.city && (
                      <Selectbox
                        name="store"
                        icon="oksag"
                        value={this.state.store}
                        options={stores}
                        onChange={(value) => this.setRetailStore(value)}
                      />
                    )}
                  </div>
                ) : (
                  $C.HAS_DELIVERY_FROM_STORE && (
                    <Button
                      classes="checkout-address__item pointer new"
                      onClick={() => this.storeSelection()}
                    >
                      {$ST.DELIVERY_FROM_STORE2}
                    </Button>
                  )
                )}
              </div>
            )}
          </div>
        </div>
        {!this.state.sameAddress && (
          <div>
            <div className="checkout-contents__header bill">
              <PageTitle>{$ST.BILLING_ADDRESS}</PageTitle>
            </div>

            <div className="checkout-contents__body">
              {this.state.isRetailStore && !this.state.store ? (
                <p>{$ST.SELECT_SHOP}</p>
              ) : (
                <div>
                  <p>{$ST.SELECT_BILLING_ADDRESS}</p>
                  <div className="row">
                    {this.renderBillingAddresses()}
                    <div className="col-6">
                      <Button
                        classes="checkout-address__item pointer new"
                        onClick={this.onAddAddress}
                      >
                        <Icon icon="arti" />
                        {$ST.CREATE_NEW_ADDRESS}
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/checkout/tfs/AddressSelection.js